import React from 'react'
import Banner from '../components/Banner'
import Navigation from '../components/Navigation'
import Hero from '../components/Hero'
import Press from '../components/Press'
import Features from '../components/Features'
import Stats from '../components/Stats'
import Integrations from '../components/Integrations'
import Pricing from '../components/Pricing'
import Reviews from '../components/Reviews'
import Comparison from '../components/Comparison'
import CTA from '../components/CTA'
import FAQ from '../components/FAQ'
import Footer from '../components/Footer'

const LandingPage = () => {
  return (
    <div className="w-full">
      <Banner />
      <Navigation />
      <Hero />
      <Press />
      <section id="features">
        <Features />
      </section>
      <Stats />
      <section id="integrations">
        <Integrations />
      </section>
      <section id="pricing">
        <Pricing />
      </section>
      <Reviews />
      <section id="compare">
        <Comparison />
      </section>
      <CTA />
      <section id="faq">
        <FAQ />
      </section>
      <Footer />
    </div>
  )
}

export default LandingPage

